import React from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { H3 } from '../../../components/atoms';
import MangopaySignupForm from './MangopaySignupForm';

const SignupMangopay = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <H3 fontWeight="600" margin="0 0 16px 0">
        {t('Signup Mangopay')}
      </H3>

      <MangopaySignupForm />
    </Box>
  );
};

export default SignupMangopay;
